import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //测试时用的网站前缀 'https://tymodule.com'
    httpurl:'https://public.tywlkj.net.cn:50169',
    //头部工具条用到属性
    barlist:[
      {name:'模型',url:'/mods',str:'mods'},
      {name:'材质',url:'/mats',str:'mats'},
      {name:'贴图',url:'/maps',str:'maps'},
    ],

    //用户相关属性
    username:'',//模块库会员_46e73b74
    id:0,
    sqlgrid:0,
    phone:0,
    role:0,
    changed:0,
    passchanged:0,
    invitecode:0,
    inviteurl: 'https://tymodule.com'+'/register',

    //预支5000
    system_advance_sqlgrid:5000,
    //邀请加1200
    system_add_sqlgrid:1200,
    //减少值
    system_subtract_sqlgrid:10,
    //支付对应
    system_supportrmb:[
      {rmb:10,sqlgrid:800},
      {rmb:25,sqlgrid:2100},
      {rmb:49,sqlgrid:4500},
      {rmb:99,sqlgrid:9300},
      {rmb:199,sqlgrid:18900},
      {rmb:399,sqlgrid:38100},
      {rmb:799,sqlgrid:76800}
    ],

    //注册时推荐人  http://localhost:8080/register?inviter=abcde
    reg_invitercode:'',
    //显示登入页还是注册页
    reg_log_state:true,

    advlist:[],
    ssyzVisible:false, //算术验证界面
    djsnum:12, //算术验证界面倒计时
    djsnumst:null,

    //是否显示修改密码界面
    reg_wjmm_state:false,
    // //修改密码验证是否通过
    // reg_xgmm_state:false,


    //提示消息
    // ui_message_type:'',
    // ui_message_msg:'',

    //navbar 搜索框类型
    searchselect:'mods',

    //记录seek页相关数据
    pseekquery:{
      sucai:'',classid:0,classcid:0,fname:'',search:'',
      colorid:0,
      styleid:0,
      px:'id',
      type:0,
      page:1,
      isone:0,
      stype:0,
      maxv:0
    },
    pseeklimit:60,
    pseektotal:0,
    pseeksucais:[],
    pseekisrunget:1,


    tseekquery:{
      sucai:'',classid:0,classcid:0,fname:'',search:'',
      colorid:0,
      styleid:0,
      px:'id',
      type:0,
      page:1,
      isone:0,
      stype:0,
      maxv:0
    },
    tseeklimit:60,
    tseektotal:0,
    tseeksucais:[],
    tseekisrunget:1,

    dseekquery:{
      sucai:'',classid:0,classcid:0,fname:'',search:'',
      colorid:0,
      styleid:0,
      px:'id',
      type:0,
      page:1,
      isone:0,
      stype:0,
      maxv:0
    },
    dseeklimit:60,
    dseektotal:0,
    dseeksucais:[],
    dseekisrunget:1,

    sseekquery:{
      sucai:'',classid:0,classcid:0,fname:'',search:'',
      colorid:0,
      styleid:0,
      px:'id',
      type:0,
      page:1,
      isone:0,
      stype:0,
      maxv:0
    },
    sseeklimit:60,
    sseektotal:0,
    sseeksucais:[],
    sseekisrunget:1,

    //记录最后的mods.matd.maps的seek页的路径
    lastroutepaths:{
      mods:'',
      mats:'',
      maps:'',
    },

    searchinput:'',
    reg_logVisible:false, //注册页显示
    yhxyVisible:false, //协议页显示
    signinVisible:false,//签到页显示
    userpanelshow:false, //用户小面板显示

    
    sucaitype:{
      1:'VR',2:'CR',3:'PBR',4:'OTHER',5:'PIC',6:'SU',12:'VR_CR'
    },
    detailitem:{},//详情页的对象
    uploaduserobj:{},//代理上传的用户列表
    classlists:{
      mods:[
        {id:1,name:'沙发',type:0,image:'/public/classimg/sf.jpg'},
        {id:2,name:'椅子',type:0,image:'/public/classimg/yz.jpg'},
        {id:3,name:'桌台',type:0,image:'/public/classimg/zt.jpg'},
        {id:4,name:'床',type:0,image:'/public/classimg/ca.jpg'},
        {id:5,name:'柜子',type:0,image:'/public/classimg/gz.jpg'},
        {id:6,name:'饰品陈设',type:0,image:'/public/classimg/bj.jpg'},
        {id:7,name:'植物',type:0,image:'/public/classimg/zw.jpg'},
        {id:8,name:'儿童家具',type:0,image:'/public/classimg/et.jpg'},
        {id:9,name:'灯具',type:0,image:'/public/classimg/dj.jpg'},
        {id:10,name:'办公家具',type:0,image:'/public/classimg/bg.jpg'},
        {id:11,name:'构件',type:0,image:'/public/classimg/gj.jpg'},
        {id:12,name:'电器',type:0,image:'/public/classimg/dq.jpg'},
        {id:13,name:'厨卫用具',type:0,image:'/public/classimg/cw.jpg'},
        {id:14,name:'器材设备',type:0,image:'/public/classimg/qc.jpg'},
        {id:15,name:'人物动物',type:0,image:'/public/classimg/rd.jpg'}
      ],
      mats:[
        {id:1,name:'石材',type:0,image:'/public/classimg/m_sc.jpg'},
        {id:2,name:'布纹',type:0,image:'/public/classimg/m_bw.jpg'},
        {id:3,name:'木纹|地板',type:0,image:'/public/classimg/m_mw.jpg'},
        {id:4,name:'皮革',type:0,image:'/public/classimg/m_pg.jpg'},
        {id:5,name:'地毯',type:0,image:'/public/classimg/m_dt.jpg'},
        {id:6,name:'金属',type:0,image:'/public/classimg/m_js.jpg'},
        {id:7,name:'墙面',type:0,image:'/public/classimg/m_qm.jpg'},
        {id:8,name:'透|半透明',type:0,image:'/public/classimg/m_bl.jpg'},
        {id:9,name:'装饰画',type:0,image:'/public/classimg/m_zsh.jpg'},
        {id:10,name:'环境',type:0,image:'/public/classimg/m_hj.jpg'},
        {id:11,name:'建筑',type:0,image:'/public/classimg/m_jz.jpg'},
        {id:12,name:'其他',type:0,image:'/public/classimg/p_qt.jpg'}
      ],
      maps:[
        {id:1,name:'石材',type:0,image:'/public/classimg/p_sc.jpg'},
        {id:2,name:'布纹',type:0,image:'/public/classimg/p_bw.jpg'},
        {id:3,name:'木纹|地板',type:0,image:'/public/classimg/p_mb.jpg'},
        {id:4,name:'皮革',type:0,image:'/public/classimg/p_pg.jpg'},
        {id:5,name:'地毯',type:0,image:'/public/classimg/p_dt.jpg'},
        {id:6,name:'金属',type:0,image:'/public/classimg/p_js.jpg'},
        {id:7,name:'墙面',type:0,image:'/public/classimg/p_qm.jpg'},
        {id:8,name:'透|半透明',type:0,image:'/public/classimg/p_bl.jpg'},
        {id:9,name:'装饰画',type:0,image:'/public/classimg/p_zsh.jpg'},
        {id:10,name:'环境',type:0,image:'/public/classimg/p_hj.jpg'},
        {id:11,name:'建筑',type:0,image:'/public/classimg/p_jz.jpg'},
        {id:79,name:'黑白凹凸',type:0,image:'/public/classimg/p_hb.jpg'},
        {id:12,name:'其他',type:0,image:'/public/classimg/p_qt.jpg'}
      ]
    },
    stylelists:[{id:1,name:'现代',type:0},{id:2,name:'后现代',type:0},{id:3,name:'中式',type:0},{id:4,name:'新中式',type:0},{id:5,name:'欧式',type:0},{id:6,name:'简欧',type:0},{id:7,name:'欧式古典',type:0},{id:8,name:'美式',type:0},{id:9,name:'法式',type:0},{id:10,name:'新古典',type:0},{id:11,name:'北欧',type:0},{id:12,name:'工业风',type:0},{id:13,name:'东南亚',type:0},{id:14,name:'地中海',type:0},{id:15,name:'日韩',type:0},{id:16,name:'自然风',type:0},{id:17,name:'洛可可',type:0},{id:18,name:'巴洛克',type:0},{id:19,name:'其他',type:0},],
    classclists:{
      mods:{
      1:[{id:16,name:'休闲单人',type:1},{id:17,name:'多人',type:1},{id:18,name:'组合',type:1},{id:19,name:'凳榻',type:1},{id:20,name:'异形沙发',type:1},{id:21,name:'贵妃椅',type:1},{id:22,name:'户外沙发',type:1},{id:23,name:'其他',type:1},],
      2:[{id:24,name:'单椅',type:2},{id:25,name:'躺椅',type:2},{id:26,name:'户外椅',type:2},{id:27,name:'公共椅',type:2},{id:28,name:'吊椅',type:2},{id:29,name:'吧台椅',type:2},{id:30,name:'按摩椅',type:2},{id:31,name:'其他',type:2},],
      3:[{id:32,name:'餐桌椅',type:3},{id:33,name:'茶桌椅',type:3},{id:34,name:'休闲桌椅',type:3},{id:35,name:'吧台',type:3},{id:36,name:'茶几',type:3},{id:37,name:'书桌椅',type:3},{id:38,name:'梳妆台',type:3},{id:39,name:'圆几角几',type:3},{id:40,name:'其他',type:3},],
      4:[{id:41,name:'单人床',type:4},{id:42,name:'双人床',type:4},{id:43,name:'床头柜',type:4},{id:44,name:'床头榻',type:4},{id:45,name:'按摩床',type:4},{id:46,name:'吊床',type:4},{id:47,name:'沙发床',type:4},{id:48,name:'其他',type:4},],
      5:[{id:49,name:'酒柜',type:5},{id:50,name:'电视柜',type:5},{id:51,name:'鞋柜',type:5},{id:52,name:'端景柜',type:5},{id:53,name:'装饰柜',type:5},{id:54,name:'书柜',type:5},{id:55,name:'衣柜',type:5},{id:56,name:'博古架',type:5},{id:57,name:'展示货架',type:5},{id:58,name:'储物柜',type:5},{id:59,name:'吊柜壁柜',type:5},{id:60,name:'其他',type:5},],
      6:[{id:61,name:'饰品摆件',type:6},{id:62,name:'挂件',type:6},{id:63,name:'雕塑',type:6},{id:64,name:'镜子',type:6},{id:65,name:'窗帘',type:6},{id:66,name:'地毯',type:6},{id:67,name:'装饰画',type:6},{id:68,name:'抱枕',type:6},{id:69,name:'软包',type:6},{id:70,name:'花瓶花艺',type:6},{id:71,name:'钟表',type:6},{id:72,name:'茶具',type:6},{id:73,name:'背景墙饰',type:6},{id:74,name:'鱼缸',type:6},{id:75,name:'书籍',type:6},{id:76,name:'生活用品',type:6},{id:77,name:'珠宝',type:6},{id:78,name:'奖品旗帜',type:6},{id:79,name:'其他',type:6},],
      7:[{id:80,name:'树',type:7},{id:81,name:'花草',type:7},{id:82,name:'灌木',type:7},{id:83,name:'竹',type:7},{id:84,name:'藤蔓植墙',type:7},{id:85,name:'盆栽',type:7},{id:86,name:'其他',type:7},],
      8:[{id:87,name:'儿童床',type:8},{id:88,name:'儿童桌椅',type:8},{id:89,name:'儿童柜子',type:8},{id:90,name:'儿童用品',type:8},{id:91,name:'玩具',type:8},{id:92,name:'其他',type:8},],
      9:[{id:93,name:'吊灯',type:9},{id:94,name:'落地灯',type:9},{id:95,name:'吸顶灯',type:9},{id:96,name:'台灯',type:9},{id:97,name:'户外灯',type:9},{id:98,name:'壁灯',type:9},{id:99,name:'儿童灯具',type:9},{id:100,name:'烛台灯',type:9},{id:101,name:'筒灯射灯',type:9},{id:102,name:'装饰灯',type:9},{id:103,name:'舞台灯',type:9},{id:104,name:'办公灯具',type:9},{id:105,name:'其他',type:9},],
      10:[{id:106,name:'接待吧台',type:10},{id:107,name:'办公桌',type:10},{id:108,name:'办公椅',type:10},{id:109,name:'办公沙发',type:10},{id:110,name:'会议桌',type:10},{id:111,name:'文件柜',type:10},{id:112,name:'办公用品',type:10},{id:113,name:'卡位',type:10},{id:114,name:'其他',type:10},],
      11:[{id:115,name:'门',type:11},{id:116,name:'窗',type:11},{id:117,name:'柱子',type:11},{id:118,name:'雕花',type:11},{id:119,name:'壁炉',type:11},{id:120,name:'五金',type:11},{id:121,name:'楼梯栏杆',type:11},{id:122,name:'线条',type:11},{id:123,name:'护墙板',type:11},{id:124,name:'拼花瓷砖',type:11},{id:125,name:'屏风花格',type:11},{id:126,name:'其他',type:11},],
      12:[{id:127,name:'音响',type:12},{id:128,name:'电视',type:12},{id:129,name:'空调风扇',type:12},{id:130,name:'电脑',type:12},{id:131,name:'手机相机',type:12},{id:132,name:'投影',type:12},{id:133,name:'洗衣机',type:12},{id:134,name:'冰箱冰柜',type:12},{id:135,name:'日用电器',type:12},{id:136,name:'其他',type:12},],
      13:[{id:137,name:'橱柜',type:13},{id:138,name:'餐具',type:13},{id:139,name:'厨房电器',type:13},{id:140,name:'台盆',type:13},{id:141,name:'食品',type:13},{id:142,name:'酒水饮料',type:13},{id:143,name:'浴缸',type:13},{id:144,name:'淋浴桑拿',type:13},{id:145,name:'浴室柜架',type:13},{id:146,name:'便器',type:13},{id:147,name:'卫浴小件',type:13},{id:148,name:'洗涤日用',type:13},{id:149,name:'其他',type:13},],
      14:[{id:150,name:'体育用品',type:14},{id:151,name:'医疗器械',type:14},{id:152,name:'游乐设备',type:14},{id:153,name:'音乐美术',type:14},{id:154,name:'汽车交通',type:14},{id:155,name:'公共设施',type:14},{id:156,name:'军用器材',type:14},{id:157,name:'工业设备',type:14},{id:158,name:'消防设施',type:14},{id:159,name:'其他',type:14},],
      15:[{id:160,name:'人物',type:15},{id:161,name:'动物',type:15},{id:162,name:'其他',type:15},],
      },
      mats:{
      1:[{id:13,name:'大理石',type:1},{id:14,name:'瓷砖',type:1},{id:15,name:'文化石',type:1},{id:16,name:'防滑砖',type:1},{id:17,name:'马赛克',type:1},{id:18,name:'拼花',type:1},{id:19,name:'岩石',type:1},{id:20,name:'云石',type:1},{id:87,name:'水磨石',type:1},{id:88,name:'人造石',type:1},],
      2:[{id:21,name:'单色纺织',type:2},{id:22,name:'格子条纹花纹',type:2},{id:23,name:'绒布',type:2},{id:24,name:'丝绸',type:2},{id:25,name:'抱枕',type:2},{id:26,name:'窗帘',type:2},{id:27,name:'灯罩',type:2},],
      3:[{id:28,name:'木器漆',type:3},{id:29,name:'木纹',type:3},{id:30,name:'条形木地板',type:3},{id:31,name:'拼花木地板',type:3},{id:32,name:'编制品',type:3},{id:33,name:'树皮|旧木',type:3},{id:34,name:'其他木',type:3},],
      4:[{id:35,name:'细纹皮',type:4},{id:36,name:'粗纹皮',type:4},{id:37,name:'花纹皮',type:4},],
      5:[{id:38,name:'现代毯',type:5},{id:39,name:'中式毯',type:5},{id:40,name:'欧式毯',type:5},{id:41,name:'动物毛毯',type:5},{id:42,name:'绒毛地毯',type:5},{id:43,name:'其他毯',type:5},],
      6:[{id:44,name:'抛光金属',type:6},{id:45,name:'拉丝金属',type:6},{id:46,name:'哑光金属',type:6},{id:47,name:'金箔银箔',type:6},{id:48,name:'其他金属',type:6},],
      7:[{id:49,name:'壁纸',type:7},{id:50,name:'花鸟背景',type:7},{id:51,name:'乳胶漆',type:7},{id:52,name:'硅藻|水泥',type:7},{id:53,name:'砖墙',type:7},{id:54,name:'其他墙面',type:7},],
      8:[{id:55,name:'玻璃',type:8},{id:56,name:'液体',type:8},{id:57,name:'塑料',type:8},{id:58,name:'其他透明',type:8},],
      9:[{id:59,name:'现代画',type:9},{id:60,name:'北欧画',type:9},{id:61,name:'中式画',type:9},{id:62,name:'油画',type:9},{id:63,name:'童趣',type:9},{id:64,name:'其他画',type:9},],
      10:[{id:65,name:'HDRI',type:10},{id:66,name:'窗外景',type:10},],
      11:[{id:67,name:'建筑地面',type:11},{id:68,name:'建筑墙面',type:11},{id:69,name:'建筑其他',type:11},],
      12:[{id:70,name:'陶瓷',type:12},{id:71,name:'图书',type:12},{id:72,name:'水果',type:12},{id:73,name:'植物',type:12},{id:74,name:'食品',type:12},{id:75,name:'鱼缸',type:12},{id:76,name:'火焰',type:12},{id:77,name:'车漆',type:12},{id:78,name:'自发光',type:12},{id:84,name:'电器',type:12},{id:85,name:'陈设品',type:12},{id:86,name:'塑胶地板',type:12},],
      79:[{id:80,name:'装饰花纹',type:79},{id:81,name:'法线凹凸',type:79},{id:82,name:'凹凸贴图',type:79},{id:83,name:'高光遮罩',type:79},]
      },
      maps:{
      1:[{id:13,name:'大理石',type:1},{id:14,name:'瓷砖',type:1},{id:15,name:'文化石',type:1},{id:16,name:'防滑砖',type:1},{id:17,name:'马赛克',type:1},{id:18,name:'拼花',type:1},{id:19,name:'岩石',type:1},{id:20,name:'云石',type:1},{id:87,name:'水磨石',type:1},{id:88,name:'人造石',type:1},],
      2:[{id:21,name:'单色纺织',type:2},{id:22,name:'格子条纹花纹',type:2},{id:23,name:'绒布',type:2},{id:24,name:'丝绸',type:2},{id:25,name:'抱枕',type:2},{id:26,name:'窗帘',type:2},{id:27,name:'灯罩',type:2},],
      3:[{id:28,name:'木器漆',type:3},{id:29,name:'木纹',type:3},{id:30,name:'条形木地板',type:3},{id:31,name:'拼花木地板',type:3},{id:32,name:'编制品',type:3},{id:33,name:'树皮|旧木',type:3},{id:34,name:'其他木',type:3},],
      4:[{id:35,name:'细纹皮',type:4},{id:36,name:'粗纹皮',type:4},{id:37,name:'花纹皮',type:4},],
      5:[{id:38,name:'现代毯',type:5},{id:39,name:'中式毯',type:5},{id:40,name:'欧式毯',type:5},{id:41,name:'动物毛毯',type:5},{id:42,name:'绒毛地毯',type:5},{id:43,name:'其他毯',type:5},],
      6:[{id:44,name:'抛光金属',type:6},{id:45,name:'拉丝金属',type:6},{id:46,name:'哑光金属',type:6},{id:47,name:'金箔银箔',type:6},{id:48,name:'其他金属',type:6},],
      7:[{id:49,name:'壁纸',type:7},{id:50,name:'花鸟背景',type:7},{id:51,name:'乳胶漆',type:7},{id:52,name:'硅藻|水泥',type:7},{id:53,name:'砖墙',type:7},{id:54,name:'其他墙面',type:7},],
      8:[{id:55,name:'玻璃',type:8},{id:56,name:'液体',type:8},{id:57,name:'塑料',type:8},{id:58,name:'其他透明',type:8},],
      9:[{id:59,name:'现代画',type:9},{id:60,name:'北欧画',type:9},{id:61,name:'中式画',type:9},{id:62,name:'油画',type:9},{id:63,name:'童趣',type:9},{id:64,name:'其他画',type:9},],
      10:[{id:65,name:'HDRI',type:10},{id:66,name:'窗外景',type:10},],
      11:[{id:67,name:'建筑地面',type:11},{id:68,name:'建筑墙面',type:11},{id:69,name:'建筑其他',type:11},],
      12:[{id:70,name:'陶瓷',type:12},{id:71,name:'图书',type:12},{id:72,name:'水果',type:12},{id:73,name:'植物',type:12},{id:74,name:'食品',type:12},{id:75,name:'鱼缸',type:12},{id:76,name:'火焰',type:12},{id:77,name:'车漆',type:12},{id:78,name:'自发光',type:12},{id:84,name:'电器',type:12},{id:85,name:'陈设品',type:12},{id:86,name:'塑胶地板',type:12},],
      79:[{id:80,name:'装饰花纹',type:79},{id:81,name:'法线凹凸',type:79},{id:82,name:'凹凸贴图',type:79},{id:83,name:'高光遮罩',type:79},]
      },
    },
    colorlist:[{id:1,name:'黑白',color:'#000'},{id:2,name:'黑色',color:'#000'},{id:3,name:'灰色',color:'#808080'},{id:4,name:'白色',color:'#fff'},{id:5,name:'金色',color:'#ffba69'},{id:6,name:'米色',color:'#ffe9cf'},{id:7,name:'浅黄',color:'#b6a387'},{id:8,name:'浅蓝',color:'#879eb6'},{id:9,name:'浅绿',color:'#87b68b'},{id:10,name:'浅红',color:'#b68787'},{id:11,name:'浅紫',color:'#b687b4'},{id:12,name:'浅褐',color:'#b69387'},{id:13,name:'深黄',color:'#5c512a'},{id:14,name:'深蓝',color:'#2b4256'},{id:15,name:'深绿',color:'#2b562e'},{id:16,name:'深红',color:'#562b2b'},{id:17,name:'深紫',color:'#562b51'},{id:18,name:'深褐',color:'#563a2b'},{id:19,name:'黄色',color:'#ffc600'},{id:20,name:'橙色',color:'#ff7800'},{id:21,name:'蓝色',color:'#008aff'},{id:22,name:'绿色',color:'#00ff06'},{id:23,name:'红色',color:'#ff0000'},{id:24,name:'紫色',color:'#ff00f6'},{id:25,name:'褐色',color:'#993c00'},],
    homenewslists:[],
    modsnewslists:[],
    matsnewslists:[],
    mapsnewslists:[],
    allnewslists:[],
  },
  getters: {
  },
  actions: {
  },
  modules: {
  }
})
